import { Pipe, PipeTransform } from '@angular/core';
import { BillDocument } from '../../types/documents/BillDocument';
import { IsActivePipe } from '../is-active.pipe';

@Pipe({
    name: 'documentActive',
    standalone: false,
})
export class DocumentActivePipe implements PipeTransform {
    constructor(private isActivePipe: IsActivePipe) {}

    transform(documents: BillDocument[], condition: boolean): BillDocument[] {
        return this.isActivePipe.transform<BillDocument>(documents, condition);
    }
}
